<template>
  <div
    :class="`${active ? 'owal-tab__container_active' : 'owal-tab__container' }`"
    @click="$emit('click')"
    >
    <slot
      v-bind="{title, active, index}"
      name="content"
      >
      <div
        :class="`${active ? 'owal-tab__content_active' : 'owal-tab__content' }`"
        >
        {{ title }}
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'OwalTab',
  props: {
    title: {
      type: String,
    },
    active: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
    },
  },
}
</script>

<style scoped>
.owal-tab__container,
.owal-tab__container_active {
  display: flex;
  flex-grow: 1;
  align-content: center;
  justify-content: center;
  font-family: 'Roboto', 'Lato', 'Avenir', 'Helvetica', sans;
  cursor: pointer;
  padding: 0;
}

.owal-tab__container_active {
  font-weight: bold;
}

.owal-tab__content,
.owal-tab__content_active {
  padding: 0.5rem;
}

</style>
